import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import IgnoredTray from "./IgnoredTray";
import { IgnoreButton, ignoreItem } from "./IgnoreButton";

export default function ManualSection({ onChange }) {
  const [rows, setRows] = useState(null);
  const [busyId, setBusyId] = useState(null);
  const [ignoreVersion, setIgnoreVersion] = useState(0);

  async function load() {
    const { data } = await api.get(`/cleanup/manual-outliers`);
    setRows(data.rows || []);
  }
  useEffect(() => { load(); }, []);

  async function afterRestore() {
    await load();
    setIgnoreVersion((v) => v + 1);
    onChange?.();
  }

  async function ignoreRow(r) {
    setBusyId(r.id);
    try {
      await ignoreItem(
        { kind: "manual", realtor_id: r.id },
        { label: r.name || "record", onUndo: afterRestore },
      );
      setRows((rs) => (rs || []).filter((x) => x.id !== r.id));
      setIgnoreVersion((v) => v + 1);
      onChange?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Ignore failed");
    } finally { setBusyId(null); }
  }

  if (rows === null) return <div className="text-sm text-slate-500">Loading…</div>;
  return (
    <div className="space-y-2">
      {rows.length === 0 && <div className="text-sm text-slate-500">No outliers.</div>}
      {rows.map((r) => (
        <div key={r.id} className="rounded-md border border-slate-200 bg-white p-3 flex items-center justify-between gap-2" data-testid={`manual-${r.id}`}>
          <div className="min-w-0">
            <div className="font-medium text-slate-900">{r.name}</div>
            <div className="text-xs text-slate-500 truncate">
              first={r.first_name || "—"} · last={r.last_name || "—"} · brokerage={r.brokerage_name}
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Link to={`/realtors/${r.id}`} className="inline-flex items-center gap-1 text-sm text-slate-700 hover:text-slate-900" data-testid={`manual-open-${r.id}`}>
              Open <ExternalLink className="h-3.5 w-3.5" />
            </Link>
            <IgnoreButton onClick={() => ignoreRow(r)} disabled={busyId === r.id} testId={`manual-ignore-${r.id}`} />
          </div>
        </div>
      ))}
      <IgnoredTray kind="manual" version={ignoreVersion} onRestored={afterRestore} />
    </div>
  );
}
